import React from 'react';

import './splash-logo.css';

/**
 * Visually, the SplashLogo looks like a molecule made up of atoms that include a round Trqk logo
 * and a graphic. It feels like an atom from a code perspective, but we will keep the design system
 * visually defined and categorize it as a molecule.
 */
export const SplashLogo = (): JSX.Element => (
    <img
        className="splashLogo object-scale-down absolute top-0 left-0 z-10"
        alt="Trqk logo"
    />
);
